<template>
  <path
    fill="currentColor"
    d="M7.75735 17.6569L9.17157 19.0711L16.2427 12L9.1716 4.92896L7.75738 6.34317L13.4142 12L7.75735 17.6569Z"
  />
</template>
